import NotFound from '@kurotetsu/online/views/NotFound';
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router-dom';

const Seat = lazy(() => import('@kurotetsu/online/views/Seat'));
function RootErrorBoundary() {
  const error = useRouteError();

  // エラーメッセージを安全に取得
  const errorMessage =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';

  if (errorMessage.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }

  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route
        path="seat/:productId/:lineId/:fromStationId/:toStationId/:direction"
        element={lazyView(<Seat />)}
      />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
